"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlatformOs = exports.PlatformOsStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
exports.PlatformOsStruct = (0, superstruct_1.enums)(["ios", "android", "web"]);
function isPlatformOs(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.PlatformOsStruct, "PlatformOs");
}
exports.isPlatformOs = isPlatformOs;
